// services/streamApi.ts
import { createApi } from "@reduxjs/toolkit/query/react";
import { streamBaseQuery } from "./streamBaseQuery";

export const streamApi = createApi({
  reducerPath: "streamApi",
  baseQuery: streamBaseQuery,
  endpoints: (builder) => ({
    streamChat: builder.query<string[], { message: string }>({
      query: (body) => ({
        url: "https://yekijfphah.us-east-1.awsapprunner.com/hiiboai/chatstream",
        body,
      }),
    }),
  }),
});

export const { useLazyStreamChatQuery } = streamApi;
